import { CaseGranulometry } from '../../../cases/CaseGranulometry';
import { getCaseOutsideStairShaftSectionsCount } from '../../../cases/queries/sections/counts/getCaseOutsideStairShaftSectionsCount';

export const mustHaveOutsideStairShaftSections = (caseGranulometry: CaseGranulometry): boolean =>
  getCaseOutsideStairShaftSectionsCount(caseGranulometry) > 0;
